import angular from 'angular';

class RejectBatch102Modal {
    /*@ngInject*/
    constructor() {}

    reject() {
        this.modalInstance.close(this.reason);
    }

    cancel() {
        this.modalInstance.dismiss();
    }
}

angular.module('batch').component('rejectBatch102Modal', {
    templateUrl: require('./modal-reject-batch-102.html'),
    controller: RejectBatch102Modal,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
